import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=5b978783&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=5b978783&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b978783",
  null
  
)

export default component.exports